(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5177],{

/***/ 66923:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nfts/staking/partner",
      function () {
        return __webpack_require__(61385);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var config_constants_supportChains__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47747);
/* harmony import */ var views_Nft_staking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15060);
/* harmony import */ var config_constants_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97971);




var StakingPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(views_Nft_staking__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        type: config_constants_types__WEBPACK_IMPORTED_MODULE_3__/* .NFT_STAKING_TYPE.PARTNER */ .lv.PARTNER
    });
};
StakingPage.chains = config_constants_supportChains__WEBPACK_IMPORTED_MODULE_1__/* .SUPPORT_NFTS */ ._e;
/* harmony default export */ __webpack_exports__["default"] = (StakingPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5060,9774,2888,179], function() { return __webpack_exec__(66923); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);